module.exports = __webpack_public_path__ + "assets/202509252035/img/wechat.444e29cb.jpg";